/** Tribe brand tokens for JS (charts, inline styles, vendor fallbacks). Hex lives here and in index.css only. */
export const brand = {
  color: {
    purple: {
      50: '#F5F0FF',
      100: '#EBE0FF',
      200: '#D6C2FF',
      300: '#BC9BFF',
      400: '#9F6EFF',
      500: '#7B3FF2',
      600: '#6528D6',
      700: '#5120AD',
      800: '#3D187F',
      900: '#2A1157',
    },
    white: '#FFFFFF',
    surface: '#F7F6FB',
    line: '#E6E4EE',
    muted: '#6B6B73',
    inkSoft: '#3A3A42',
    ink: '#0E0E10',
    success: '#1FA971',
    warning: '#F5A524',
    danger: '#E5484D',
    reward: '#FFC53D',
  },
  radius: { sm: 10, md: 16, lg: 24, pill: 999 },
  font: { display: 'Fredoka', body: 'Nunito' },
};

/** Default vendor/pass accent when a tenant has not set brand_color */
export const DEFAULT_BRAND_COLOR = brand.color.purple[500];
export const DEFAULT_ON_BRAND = brand.color.white;
